import { useEnvContext } from "context/EnvContext";
import { APP_CAREPROVIDER } from "core/consts";
import { isPrintMode } from "core/model/utils/urls";
import { useMedia } from "dsl/atoms/ResponsiveMedia";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const useShouldDeactivateCrisp = () => {
  const { app } = useEnvContext();
  const { isMobile } = useMedia();
  const location = useLocation();

  const shouldHide = useMemo(() => {
    if (isPrintMode()) return true;
    if (app !== APP_CAREPROVIDER) return false;

    const { pathname } = location;
    const isCareproviderAuthPage = pathname.includes("/careprovider/auth");

    const isCareproviderAdmissions = pathname.includes(
      "/careprovider/admissions",
    );

    return (isMobile && !isCareproviderAuthPage) || isCareproviderAdmissions;
  }, [app, isMobile, location]);

  return shouldHide;
};

export default useShouldDeactivateCrisp;
